export const excerpt = (text: string, length: number) =>
    text.length <= length ? text : `${text.slice(0, length).trimEnd()}…`;

export const email_formater = (email: string) => {
    return capitalize(email.split('@')[0]);
};

export const capitalize = (text: string) => text.charAt(0).toUpperCase() + text.slice(1);
